import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import { createApp } from 'vue'
import App from './App.vue'
import router from './router/routes'
import store from './store'
import axios from 'axios'
import Cookies from 'js-cookie'
import VueCookies from 'vue-cookies'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/css/sweetalert-mobile.css'
import './assets/css/sweetalert-custom.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faLock, faSignOutAlt, faBars, faBell, faHome, faHistory, faWallet, faMapMarkerAlt, faArrowLeft, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import Swal from 'sweetalert2'
import OneSignalVuePlugin from '@onesignal/onesignal-vue3';
import moment from 'moment'

// Add FontAwesome icons
library.add(faUser, faLock, faSignOutAlt, faBars, faBell, faHome, faHistory, faWallet, faMapMarkerAlt, faArrowLeft, faCheck, faTimes, faWhatsapp)

// Verificar si hay datos de autenticación en localStorage y sincronizar con cookies si es necesario
const syncAuthData = () => {
  const accessToken = localStorage.getItem('access_token')
  const id = localStorage.getItem('id')
  const email = localStorage.getItem('email')
  const expiresAt = localStorage.getItem('expires_at')
  
  if (accessToken && expiresAt) {
    // Verificar si el token ha expirado
    const now = moment()
    const expiration = moment(expiresAt)
    
    if (now.isBefore(expiration)) {
      // Token válido, sincronizar con cookies si no existen
      if (!Cookies.get('access_token')) {
        const expiresAtDate = new Date(expiresAt)
        Cookies.set('access_token', accessToken, { expires: expiresAtDate })
        if (id) Cookies.set('id', id, { expires: expiresAtDate })
        if (email) Cookies.set('email', email, { expires: expiresAtDate })
      }
      
      // Configurar Axios con el token
      axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken
    } else {
      // Token expirado, limpiar localStorage
      localStorage.removeItem('access_token')
      localStorage.removeItem('id')
      localStorage.removeItem('email')
      localStorage.removeItem('expires_at')
    }
  }
}

// Ejecutar sincronización al iniciar
syncAuthData()

const app = createApp(App)

// Configuración de Sentry
Sentry.init({
  app,
  dsn: "https://0e8302240a8398432f2fe0b9bf279f3a@o4511332547035136.ingest.us.sentry.io/4511360324468736",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    // Sentry.replayIntegration({
    //   maskAllText: false,
    //   blockAllMedia: false,
    // }),
    Sentry.captureConsoleIntegration({
      levels: ['error']
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  environment: window.location.hostname === 'driver.amidrivers.com' ? 'production' :
                window.location.hostname === 'amidriver.myticktap.com' ? 'quality' : 'development',
});

// --- Determinar App ID y Service Worker Path de OneSignal según el entorno ---
let oneSignalAppId = 'e053c4c1-dd6e-491d-a5a1-9c5405992b9b'; // Default: local
// Ya no necesitamos serviceWorkerPath, OneSignal lo buscará en la raíz
const hostname = window.location.hostname;

if (hostname === 'driver.amidrivers.com') {
  oneSignalAppId = 'e053c4c1-dd6e-491d-a5a1-9c5405992b9b'; // Production
} else if (hostname === 'amidriver.myticktap.com') {
  oneSignalAppId = '7a642e8e-a2c7-461c-ba68-8b39048529c3'; // Quality
} else if (hostname === 'localhost' || hostname === '127.0.0.1') {
  oneSignalAppId = '4cbdd956-9b64-4a8a-825b-b4518e7245a6'; // Local (explícito)
}

console.log(`OneSignal: Inicializando para el entorno: ${hostname} con App ID: ${oneSignalAppId}. Buscando Service Worker en la raíz.`);
// --- Fin lógica App ID y Service Worker Path ---

// Inicializar el servicio de notificaciones después de montar la aplicación
app.config.globalProperties.$axios = axios;

// Método global para verificar el estado de las notificaciones (probablemente a eliminar/modificar más adelante)
app.config.globalProperties.$checkNotifications = async function() {
  return await notificationService.checkRegistrationStatus();
};

// Interceptor para las solicitudes
axios.interceptors.request.use(
    function(config) {
      config["headers"] = {
        Authorization: "Bearer " + Cookies.get("access_token"),
        tokentap:'Sb7qmGAxCrqdZz370F5cGSNrcQNidjQ2',
        Accept: "application/json"
      };
      config["onUploadProgress"] = progressEvent => {
       /* store.dispatch(
          "update_upload_percentage",
          Math.round((progressEvent.loaded * 100) / progressEvent.total)
        );*/
      };
  
      return config;
    },
    error => Promise.reject(error)
);

// Variable para controlar redirecciones
let isRedirecting = false;

// Interceptor para las respuestas
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Manejo de errores comunes como 401, 403, 500, etc.
    if (error.response && error.response.status === 401 && !isRedirecting) {
      // Prevenir múltiples redirecciones
      isRedirecting = true;
      
      // Limpiar todos los datos de autenticación
      Cookies.remove('access_token');
      Cookies.remove('id');
      Cookies.remove('email');
      localStorage.removeItem('access_token');
      localStorage.removeItem('id');
      localStorage.removeItem('email');
      localStorage.removeItem('expires_at');
      
      // Limpiar el header de autorización
      delete axios.defaults.headers.common["Authorization"];
      
      // Si ya estamos en login, no mostrar el alert ni redirigir
      if (window.location.pathname !== '/login') {
        // Mostrar SweetAlert antes de redirigir
        Swal.fire({
          title: 'Sesión expirada',
          text: 'Serás redirigido a el login',
          icon: 'warning',
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false
        }).then(() => {
          window.location.href = '/login';
        });
      }
      
      return new Promise(() => {});
    }
    
    return Promise.reject(error);
  }
);

app.config.globalProperties.$cookies = Cookies;

app.component('font-awesome-icon', FontAwesomeIcon)

// Configurar Axios globalmente (si aún no está hecho)
// TODO: Mover esto a un archivo de configuración si es necesario
app.config.globalProperties.$axios.defaults.baseURL = 'https://tu-api.com/api';

// Usar el plugin de OneSignal con el App ID determinado
// OneSignal buscará automáticamente OneSignalSDKWorker.js y OneSignalSDKUpdaterWorker.js en la raíz (public/)
app.use(OneSignalVuePlugin, {
  appId: oneSignalAppId,
  // TODO: Añadir serviceWorkerUpdaterPath si existen los archivos updater específicos
});

app.use(router)
app.use(store)
app.use(VueCookies)

// Montar la aplicación
app.mount('#app')
